import { MultiColumnAutoCompleteState } from './types';

export const multiColumnAutoCompleteInitialState: MultiColumnAutoCompleteState =
  {
    activeColumnIndex: 0,
    activeOptionIndex: 0,
    groupKey: '',
    activeRowIndex: 0,
    optionIndexByOptionID: {},
    columnOptionLimitByRowID: {},
    groupsByRowColumn: [],
    optionIDByRowColumnOptionIndex: [],
  };
